import CloseIcon from '@mui/icons-material/Close';
import {
    AppBar,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
    Slide,
    Toolbar,
    Typography,
    useTheme
} from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import React, { FC, forwardRef, useEffect, useMemo, useState } from 'react';
import { SearchInput } from '../../../Form/InputSearch/input-search.component';
import { ListProductUseCase } from '../../../../Usecase/Products/list-product-usecase';
import { useToast } from '../../../../Hooks/ToasContext';
import { IProductEntity } from '../../../../Services/api/products/products.interface';
import { Table } from '../../../Table/table.component';
import { Environment } from '../../../../Config/constants';
interface ISelectProductVariantProps {
    data: any
    onClose: () => void
    onSearch: (value: string) => void
    onSelect: (value: any) => void
    listProductsUseCase: ListProductUseCase
    brand?: string
}


const SelectProductVariant : FC<ISelectProductVariantProps> = ({ data, onClose, onSearch, onSelect, listProductsUseCase, brand }) => {
  console.log("brand interno: ", brand)
    const [loading, setLoading] = useState(false)
    const [products, setProducts] = useState<IProductEntity[]>([])
    const { showToast } = useToast()


  
  const listProducts = async ({ page, searchBy }: { page :number; searchBy?: string}) => {
        
    try {
      setLoading(true)
      
      const listResult = await listProductsUseCase.handle({ page: 1, searchBy, brand: brand ?? '' });

      if (listResult.isFailure) {
        showToast(String(listResult?.error?.error), 'error');
        return;
      }

     const response = listResult.getValue()

      console.log("listProducts: ", response)

      if(response?.data?.length) {
        setProducts(response?.data)
      } else {
        setProducts([])
      }
      
   
     

    } catch (error) {
      console.log("error listArts function: ", error)
    } finally {
      setLoading(false);
    }
  };

  const columns = useMemo(() => {
    const createColumns: any[] = [
      {
        field: 'photo',
        headerName: 'Imagem',
        renderCell: (params: any) => <Box component='img' src={params?.row?.images[0]?.link || Environment.IMAGE_PLACEHOLDER} sx={{ width: '80px', height: '80px', objectFit: 'contain'}} />
      },
      {
        field: 'name',
        flex: 1,
        headerName: 'Produto',
      }
    ];
  
    return createColumns;
  }, []);

  useEffect(() => {
    listProducts({ page: 1 })
  }, [])

  

  return (
    <>
      <Dialog
        open
        // TransitionComponent={Transition}
        keepMounted
        onClose={onClose}
        aria-describedby="alert-dialog-slide-description"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Buscar Produto</DialogTitle>
        <DialogContent>
           <SearchInput
                sx={{ width: '100%', }}
                placeholder="Busque pelo nome do Produto..."
                onSearch={listProducts}
            />

            <Table data={products} columns={columns} totalCount={0} pagination={false} isRowSelectable={() => false} disableRowSelectionOnClick={false} onSelect={onSelect} onRowClick={onSelect} />

        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancelar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SelectProductVariant;
